import { createReducer, createSelector } from '@reduxjs/toolkit'
import { CommonCare } from '../../core/models/CommonCare'
import { retrieveCommonCares } from '../../core/use-cases/retrieveCommonCares'
import { AppState } from '../store'

type CommonCaresState = {
  loading: boolean
  value: CommonCare[]
}

const initialState: CommonCaresState = {
  loading: false,
  value: [],
}

export const commonCaresReducer = createReducer(initialState, builder => {
  builder.addCase(retrieveCommonCares.pending, state => {
    state.loading = true
    state.value = []
  })
  builder.addCase(retrieveCommonCares.fulfilled, (state, action) => {
    state.loading = false
    state.value = action.payload
  })
})

export const selectCommonCares = (state: AppState) => state.commonCares

export const selectCommonCareById = (id: string) =>
  createSelector(selectCommonCares, state =>
    state.value.find(ccamCode => ccamCode.id === id)
  )
